module.exports = __webpack_public_path__ + "img/扶梯6.2f3f61d4.png";